export const ACCESS_POINTS = {
    // LABELS_SETUP_VIEW: '10028',
    // LABELS_SETUP_EDIT: '20028',
    // SHELL_SETUP_VIEW: '11122',
    // SHELL_SETUP_EDIT: '21122',
    // TEMPLATE_SETUP_VIEW: '11123',
    // TEMPLATE_SETUP_EDIT: '21123',
    LABELS_ADD: '95001',
    LABELS_DELETE: '85001',
    LABELS_EDIT: '75001',
    LABELS_VIEW: '65001',
    THEMES_ADD: '95002',
    THEMES_DELETE: '85002',
    THEMES_EDIT: '75002',
    THEMES_VIEW: '65002',
    CONFIGURATION_ADD: '95003',
    CONFIGURATION_DELETE: '85003',
    CONFIGURATION_EDIT: '75003',
    CONFIGURATION_VIEW: '65003',
    CUSTOMCONTENT_ADD: '95004',
    CUSTOMCONTENT_DELETE: '85004',
    CUSTOMCONTENT_EDIT: '75004',
    CUSTOMCONTENT_VIEW: '65004',
    TRACKINGHOOKS_ADD: '95005',
    TRACKINGHOOKS_DELETE: '85005',
    TRACKINGHOOKS_EDIT: '75005',
    TRACKINGHOOKS_VIEW: '65005',
    THIRD_PARTY_ADD: '95006',
    THIRD_PARTY_DELETE: '85006',
    THIRD_PARTY_EDIT: '75006',
    THIRD_PARTY_VIEW: '65006'
};

export const ACCESS_POINT_LEVEL = {
    FULL: 'FULL',
    VIEW: 'VIEW',
    EDIT: 'EDIT',
    ADD: 'ADD',
    DELETE: 'DELETE'
};

export const ACCESS_POINTS_GROUP = {
    CUSTOM_CONTENT: 'customcontent',
    TRACKING_HOOKS: 'trackinghooks',
    LABELS: 'labels',
    THEMES: 'themes',
    CONFIGURATION: 'configuration',
    THIRD_PARTY: 'thirdParty'
};

export const CATEGORY_OF_PAGE = {
    LABELS: 'Labels',
    SETTINGS: 'Settings'
};

export const CONTENT_TYPES = {
    THEME: 'THEME',
    CONFIG: 'CONFIG',
    THIRD_PARTY: 'THIRD_PARTY'
};



// WEBPACK FOOTER //
// ./src/constants/AccessPoints.js